import React, { useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import FormContext from "../context/formContext";
import { useToast } from "@chakra-ui/react";
import BackLogout from "../component/backLogout";
import Loader from "../component/loader";

function FormPage2() {
  const toast = useToast();
  const context = useContext(FormContext);
  const {
    loginObj,
    setLoginObj,
    stateArr,
    stateList,
    backward,
    editable,
    setEditable,
    reversepage,
    setReversepage,
    disableinput,
    setDisableinput,
  } = context;
  const navigate = useNavigate();

  const [yearDrop, setYearDrop] = useState([]);
  const [fp2loader, setFP2loader] = useState(false);
  const [totalPCBE, setTotalPCBE] = useState([0]);
  const [totalPCME, setTotalPCME] = useState([0]);
  const [totalObtainedPCBE, setTotalObtainedPCBE] = useState([0]);
  const [totalObtainedPCME, setTotalObtainedPCME] = useState([0]);
  // newadd for blur
  const [phyinputDisabled, setPhyInputDisabled] = useState(false);
  const [chemInputDisable, setChemInputDisable] = useState(false);
  const [enginputDisabled, setengInputDisabled] = useState(false);
  const [mathInputDisable, setmathInputDisable] = useState(false);
  const [bioinputDisabled, setbioInputDisabled] = useState(false);
  const [resetDisabled, setResetDisabled] = useState(false);

  // resetfunction
  const Reset = () => {
    const updatedLoginObj = {
      ...loginObj,
      twlBMarksObt: "",
      twlMMarksObt: "",
      twlPMarksObt: "",
      twlEMarksObt: "",
      twlCMarksObt: "",
      twlPMaxMarks: "",
      twlCMaxMarks: "",
      twlEMaxMarks: "",
      twlMMaxMarks: "",
      twlBMaxMarks: "",
      twlMaxMarksPCME: "",
      twlPCMEMarks: "",
      twlPCMEPercentage: "",
      twlMaxMarksPCBE: "",
      twlPCBEMarks: "",
      twlPCBEPercentage: "",
    };
    setLoginObj(updatedLoginObj);
    setEditable(true);
    setReversepage(false);
    setPhyInputDisabled(false);
    setChemInputDisable(false);
    setengInputDisabled(false);
    setmathInputDisable(false);
    setbioInputDisabled(false);
    setResetDisabled(false);
    setDisableinput(false);
  };

  const createarray = (e) => {
    var currentyear = new Date().getFullYear();
    var arrayyer = [];
    for (let i = currentyear; i >= 1970; i--) {
      arrayyer.push(i);
    }
    setYearDrop(arrayyer);
  };

  const handlePositive = (e) => {
    let input = e.target.value;
    const pattern = /^[0-9]*$/;
    if (pattern.test(input)) {
      e.target.value = input;
    } else {
      e.target.value = null;
    }
  };

  const handleSaveFormPage2 = () => {
    loginObj["student_id"] = localStorage.getItem("studentId");
    loginObj["db_name"] = "erp_eshiksa";
    if (loginObj.postalCode.length === 6) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Cookie", "ci_session=gliuijh4lm0h2rlafbvtgo6r8vj6f9if");
      myHeaders.append("auth_token", localStorage.getItem("token"));
      var raw = JSON.stringify(loginObj);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch("https://erpapi.eshiksa.net/Gadvasu/SaveData.php", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          var responseObjFS = JSON.parse(result);
          if (responseObjFS.success === 1) {
            setFP2loader(false);
            toast({
              title: "Alert",
              description: responseObjFS.msg,
              status: "success",
              duration: 1000,
              isClosable: true,
              position: "top",
            });
            navigate("/FormPage3");
          } else {
            toast({
              title: "Alert",
              description: responseObjFS.msg,
              status: "error",
              duration: 1000,
              isClosable: true,
              position: "top",
            });
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      toast({
        title: "Alert",
        description: "Please fill correct Postal code",
        status: "error",
        duration: 1000,
        isClosable: true,
        position: "top",
      });
    }
  };

  const handleSubmitPage2 = (e) => {
    e.preventDefault();
    setFP2loader(true);
    let pcbepercent = loginObj.twlPCBEPercentage;
    let pcmepercent = loginObj.twlPCMEPercentage;
    if (loginObj.resident === "Yes") {
      if (loginObj.subjectsName === "PCBE") {
        if (
          (loginObj.student_Category === "General" ||
            loginObj.student_Category === "Gen/EWS") &&
          loginObj.whetherDisabled === "No"
        ) {
          if (pcbepercent >= 50) {
            handleSaveFormPage2();
          } else {
            toast({
              title: "Alert",
              description: "Sorry, You fall below the cuttoff.",
              status: "error",
              duration: 1000,
              isClosable: true,
              position: "top",
            });
          }
        } else {
          if (pcbepercent >= 40) {
            handleSaveFormPage2();
          } else {
            toast({
              title: "Alert",
              description: "Sorry, You fall below the cuttoff.",
              status: "error",
              duration: 1000,
              isClosable: true,
              position: "top",
            });
          }
        }
      } else if (loginObj.subjectsName === "PCME") {
        if (
          (loginObj.student_Category === "General" ||
            loginObj.student_Category === "Gen/EWS") &&
          loginObj.whetherDisabled === "No"
        ) {
          if (pcmepercent >= 50) {
            handleSaveFormPage2();
          } else {
            toast({
              title: "Alert",
              description: "Sorry, You fall below the cuttoff.",
              status: "error",
              duration: 1000,
              isClosable: true,
              position: "top",
            });
          }
        } else {
          if (pcmepercent >= 40) {
            handleSaveFormPage2();
          } else {
            toast({
              title: "Alert",
              description: "Sorry, You fall below the cuttoff.",
              status: "error",
              duration: 1000,
              isClosable: true,
              position: "top",
            });
          }
        }
      } else if (loginObj.subjectsName === "PCBME") {
        if (
          (loginObj.student_Category === "General" ||
            loginObj.student_Category === "Gen/EWS") &&
          loginObj.whetherDisabled === "No"
        ) {
          if (pcbepercent >= 50 && pcmepercent >= 50) {
            handleSaveFormPage2();
          } else {
            if (pcbepercent >= 50 && pcmepercent <= 50) {
              navigate("/FormStart");
              toast({
                title: "Alert",
                description: "Please Select Subject with Biology only.",
                status: "warning",
                duration: 3000,
                isClosable: true,
                position: "top",
              });
            } else if (pcbepercent <= 50 && pcmepercent >= 50) {
              navigate("/FormStart");
              toast({
                title: "Alert",
                description: "Please Select Subject with Maths only.",
                status: "warning",
                duration: 3000,
                isClosable: true,
                position: "top",
              });
            } else {
              toast({
                title: "Alert",
                description: "Sorry, You fall below the cuttoff.",
                status: "error",
                duration: 1000,
                isClosable: true,
                position: "top",
              });
            }
          }
        } else {
          if (pcbepercent >= 40 && pcmepercent >= 40) {
            handleSaveFormPage2();
          } else {
            if (pcbepercent >= 40 && pcmepercent <= 40) {
              navigate("/FormStart");
              toast({
                title: "Alert",
                description: "Please Select Subject with Biology only.",
                status: "warning",
                duration: 3000,
                isClosable: true,
                position: "top",
              });
            } else if (pcbepercent <= 40 && pcmepercent >= 40) {
              navigate("/FormStart");
              toast({
                title: "Alert",
                description: "Please Select Subject with Maths only.",
                status: "warning",
                duration: 3000,
                isClosable: true,
                position: "top",
              });
            } else {
              toast({
                title: "Alert",
                description: "Sorry, You fall below the cuttoff.",
                status: "error",
                duration: 1000,
                isClosable: true,
                position: "top",
              });
            }
          }
        }
      }
    } else {
      if (loginObj.subjectsName === "PCBE") {
        if (pcbepercent >= 50) {
          handleSaveFormPage2();
        } else {
          setFP2loader(false);
          toast({
            title: "Alert",
            description: "Sorry, You fall below the cuttoff.",
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      } else if (loginObj.subjectsName === "PCME") {
        if (pcmepercent >= 50) {
          handleSaveFormPage2();
        } else {
          setFP2loader(false);
          toast({
            title: "Alert",
            description: "Sorry, You fall below the cuttoff.",
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      } else if (loginObj.subjectsName === "PCBME") {
        if (pcbepercent >= 50 && pcmepercent >= 50) {
          handleSaveFormPage2();
        } else {
          if (pcbepercent >= 50 && pcmepercent <= 50) {
            navigate("/FormStart");

            toast({
              title: "Alert",
              description: "Please Select Subject with Biology only.",
              status: "warning",
              duration: 3000,
              isClosable: true,
              position: "top",
            });
          } else if (pcbepercent <= 50 && pcmepercent >= 50) {
            navigate("/FormStart");

            toast({
              title: "Alert",
              description: "Please Select Subject with Maths only.",
              status: "warning",
              duration: 3000,
              isClosable: true,
              position: "top",
            });
          } else {
            setFP2loader(false);
            toast({
              title: "Alert",
              description: "Sorry, You fall below the cuttoff.",
              status: "error",
              duration: 1000,
              isClosable: true,
              position: "top",
            });
          }
        }
      }
    }
  };

  useEffect(() => {
    window.onbeforeunload = () => {
      return "";
    };
    window.scrollTo(0, 0);
    stateList();
    createarray();
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    let tenthPercent = (loginObj.tenMarksObt / loginObj.tenMaxMarks) * 100;
    setLoginObj({ ...loginObj, tenMarksPercent: tenthPercent });
  }, [loginObj.tenMarksObt, loginObj.tenMaxMarks]);

  useEffect(() => {
    let totalMarksArrayB = Object.values(totalPCBE).map((item) =>
      parseInt(item)
    );
    let TotalB = totalMarksArrayB.reduce((a, b) => a + b);
    let totalMarksArrayM = Object.values(totalPCME).map((item) =>
      parseInt(item)
    );
    let TotalM = totalMarksArrayM.reduce((a, b) => a + b);
    setLoginObj({
      ...loginObj,
      twlMaxMarksPCBE: TotalB,
      twlMaxMarksPCME: TotalM,
    });
    // setLoginObj({ ...loginObj, twlMaxMarksPCME: TotalM });
    // eslint-disable-next-line
  }, [totalPCBE, totalPCME]);

  useEffect(() => {
    let totalMarksObtArray = Object.values(totalObtainedPCBE).map((item) =>
      parseInt(item)
    );
    let TotalObt = totalMarksObtArray.reduce((a, b) => a + b);
    let totalMarksObtArrayM = Object.values(totalObtainedPCME).map((item) =>
      parseInt(item)
    );
    let TotalObtM = totalMarksObtArrayM.reduce((a, b) => a + b);
    setLoginObj({
      ...loginObj,
      twlPCBEMarks: TotalObt,
      twlPCMEMarks: TotalObtM,
    });
  }, [totalObtainedPCBE, totalObtainedPCME]);

  useEffect(() => {
    let PCMEpercnt = (loginObj.twlPCMEMarks / loginObj.twlMaxMarksPCME) * 100;
    let PCBEpercnt = (loginObj.twlPCBEMarks / loginObj.twlMaxMarksPCBE) * 100;
    const roundedPCME = parseFloat(PCMEpercnt).toFixed(2);
    const roundedPCBE = parseFloat(PCBEpercnt).toFixed(2);
    setLoginObj({
      ...loginObj,
      twlPCMEPercentage: roundedPCME,
      twlPCBEPercentage: roundedPCBE,
    });
  }, [
    loginObj.twlPCMEMarks,
    loginObj.twlMaxMarksPCME,
    loginObj.twlMaxMarksPCBE,
    loginObj.twlPCBEMarks,
  ]);

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=ks1r6e3hp01h9psp1ufu608e45l56ri4");
    myHeaders.append("auth_token", localStorage.getItem("token"));
    var raw = JSON.stringify({
      // Branch_id: "1729",
      Branch_id: "2244",
      student_id: localStorage.getItem("studentId"),
      db_name: "erp_eshiksa",
      email: localStorage.getItem("email"),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://erpapi.eshiksa.net/Gadvasu/getStudentData.php",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        var resultObj = JSON.parse(result);
        if (resultObj.success === 1) {
          setLoginObj(resultObj.form_data);
        } else {
          toast({
            title: "Alert",
            description: resultObj.msg,
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      })
      .catch((error) => console.log("error", error));
  }, []);

  const handlepin = (e) => {
    let input = e.target.value;
    const pattern = /^[0-9]*$/;
    if (pattern.test(input)) {
      e.target.value = input.slice(0, 6);
    } else {
      e.target.value = null;
    }
  };

  // disablefunction
  const handleBlur = () => {
    if (loginObj.twlPMarksObt !== "") {
      setPhyInputDisabled(true);
    }
  };

  const handlechemBlur = () => {
    if (loginObj.twlCMarksObt !== "") {
      setChemInputDisable(true);
    }
  };

  const handlemath = () => {
    if (loginObj.twlMMarksObt !== "") {
      setmathInputDisable(true);
    }
  };

  const handlebio = () => {
    if (loginObj.twlBMarksObt !== "") {
      setbioInputDisabled(true);
    }
  };

  const handleengBlur = () => {
    if (loginObj.twlEMarksObt !== "") {
      setengInputDisabled(true);
    }
  };

  // useEffect(() => {
  //   const isRefreshed =
  //     performance &&
  //     performance.navigation &&
  //     performance.navigation.type === performance.navigation.TYPE_RELOAD;
  //   if (isRefreshed) {
  //     setReversepage(true);
  //   }
  // }, []);

  // refreshpage
  useMemo(() => {
    const isRefreshed =
      performance &&
      performance.navigation &&
      performance.navigation.type === performance.navigation.TYPE_RELOAD;
    if (isRefreshed) {
      setReversepage(true);
    }
  }, []);

  return (
    <React.Fragment>
      <div className="container">
        <div>
          <button
            className="btn btn-sm my-2 "
            style={{ border: "1px solid #a6191f", color: "#a6191f" }}
          >
            {" "}
            <i className="fa-solid fa-user mx-2"> </i>
            {loginObj.name}
          </button>
          <BackLogout />
        </div>

        <form onSubmit={(e) => handleSubmitPage2(e)}>
          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Address Details</h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Address Line 1*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Address Line 1"
                  name="addLine1"
                  value={loginObj.addLine1}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Address Line 2</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Address Line 2"
                  name="addLine2"
                  value={loginObj.addLine2}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">City*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="City"
                  name="city"
                  value={loginObj.city}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Country*</label>
                <select
                  className="form-select"
                  name="country"
                  value={loginObj.country}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="India">India</option>
                </select>
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">State/Province*</label>
                <select
                  name="stateNameAdd"
                  value={loginObj.stateNameAdd}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {stateArr.map((item, i) => {
                    return (
                      <option key={i} value={item.state_name}>
                        {item.state_name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Postal code*</label>
                <input
                  type="number"
                  className="form-control number-input"
                  placeholder="Postal Code"
                  name="postalCode"
                  value={loginObj.postalCode}
                  onKeyUp={handlepin}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div>
          </div>

          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Educational Information- 10th</h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Name of the School- 10th*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name of the School- 10th"
                  name="tenSchoolName"
                  value={loginObj.tenSchoolName}
                  onChange={(e) => {
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    });
                    createarray(e);
                  }}
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Board- 10th*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Board- 10th"
                  name="tenSchoolBoard"
                  value={loginObj.tenSchoolBoard}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Year of Passing - 10th*</label>
                <select
                  name="tenPassYear"
                  value={loginObj.tenPassYear}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {yearDrop.map((item, i) => {
                    return (
                      <option key={i} value={item}>
                        {item}{" "}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Percentage - 10th *</label>
                <input
                  type="number"
                  className="form-control number-input"
                  placeholder="Percentage - 10th"
                  name="tenMarksPercent"
                  value={loginObj.tenMarksPercent}
                  onKeyUp={(e) => handlePositive(e)}
                  onChange={(e) => {
                    if (e.target.value < 101) {
                      let input = e.target.value;
                      e.target.value = input.slice(0, 5);
                      setLoginObj({
                        ...loginObj,
                        [e.target.name]: e.target.value,
                      });
                    } else {
                      e.target.value = 0;
                    }
                  }}
                  required
                />
              </div>
            </div>
          </div>

          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Educational Information- 12th</h6>
              </div>
            </div>

            <div className="row p-3">
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">
                  Name of the Institute- 12th*
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name of the School- 12th"
                  name="twlSchoolName"
                  value={loginObj.twlSchoolName}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Board- 12th*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Board- 12th"
                  name="twlBoardName"
                  value={loginObj.twlBoardName}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Year of Passing - 12th*</label>
                <select
                  name="twlPassYear"
                  value={loginObj.twlPassYear}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {yearDrop.map((item, i) => {
                    return (
                      <option key={i} value={item}>
                        {item}{" "}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Exam Status-12th*</label>
                <select
                  name="twlExamStatus"
                  value={loginObj.twlExamStatus}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="Passed">Passed</option>
                </select>
              </div>
            </div>

            <label className="form-label">Stream*</label>
            <div className="row p-3 d-flex justify-content-between">
              <div className="col-sm-12 col-lg-3">
                <select
                  name="twlStream"
                  value={loginObj.subjectsName}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                  disabled
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="PCBE">Medical</option>
                  <option value="PCME">Non-Medical</option>
                  <option value="PCBME">Medical & Non-Medical</option>
                </select>
              </div>

              <div className="col-sm-12 col-lg-3">
                <div className="row justify-content-end p-3 p-md-0">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={Reset}
                  >
                    Set Marks
                  </button>
                </div>
              </div>
            </div>

            <div className="row p-3 mx-auto">
              <table className="table tabWidth mx-auto border ">
                <thead>
                  <tr className="text-center">
                    <th scope="col-2">Subject</th>
                    <th scope="col">Max. Marks</th>
                    <th scope="col">Marks Obtained</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="fw-bold w-25 mx-auto text-center pt-3">
                      {" "}
                      Physics{" "}
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input "
                        placeholder="Physics Max Marks"
                        name="twlPMaxMarks"
                        value={loginObj.twlPMaxMarks}
                        onKeyUp={(e) => handlePositive(e)}
                        onChange={(e) => {
                          setLoginObj({
                            ...loginObj,
                            [e.target.name]: e.target.value,
                          });
                          setTotalPCBE({
                            ...totalPCBE,
                            [e.target.name]: e.target.value,
                          });
                          setTotalPCME({
                            ...totalPCME,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        disabled={
                          loginObj.twlPMarksObt !== "" ||
                          (!editable && !backward)
                        }
                        required
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input input-1"
                        placeholder="Physics Marks Obtained"
                        name="twlPMarksObt"
                        value={loginObj.twlPMarksObt}
                        maxLength={loginObj.twlPMaxMarks}
                        min="0"
                        max={loginObj.twlPMaxMarks}
                        onInput={(e) => {
                          const inputValue = parseInt(e.target.value);
                          if (inputValue > e.target.maxLength) {
                            toast({
                              title: "Alert",
                              description: "Check marks obtained or note below",
                              status: "error",
                              duration: 1000,
                              isClosable: true,
                              position: "top",
                            });
                          }
                          handlePositive(e);
                        }}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value);
                          const phymarks = loginObj.twlPMaxMarks;
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= phymarks
                          ) {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: inputValue,
                            });
                            setTotalObtainedPCBE({
                              ...totalObtainedPCBE,
                              [e.target.name]: inputValue,
                            });
                            setTotalObtainedPCME({
                              ...totalObtainedPCME,
                              [e.target.name]: inputValue,
                            });
                          } else {
                            toast({
                              title: "Alert",
                              description: "Check marks obtained or note below",
                              status: "error",
                              duration: 1000,
                              isClosable: true,
                              position: "top",
                            });
                          }
                        }}
                        onBlur={handleBlur}
                        // disabled={
                        //   phyinputDisabled ||
                        //   (!editable && !backward) ||
                        //   reversepage
                        // }
                        disabled={
                          phyinputDisabled ||
                          (!editable && !backward) ||
                          reversepage ||
                          disableinput
                        }
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-bold w-25 mx-auto text-center pt-3">
                      {" "}
                      Chemistry{" "}
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input"
                        placeholder="Chemistry Max Marks"
                        name="twlCMaxMarks"
                        value={loginObj.twlCMaxMarks}
                        onKeyUp={(e) => handlePositive(e)}
                        onChange={(e) => {
                          setLoginObj({
                            ...loginObj,
                            [e.target.name]: e.target.value,
                          });
                          setTotalPCBE({
                            ...totalPCBE,
                            [e.target.name]: e.target.value,
                          });
                          setTotalPCME({
                            ...totalPCME,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        // disabled={!editable && !backward}
                        disabled={
                          loginObj.twlCMarksObt !== "" ||
                          (!editable && !backward)
                        }
                        required
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input input-2"
                        placeholder="Chemistry Marks Obtained"
                        name="twlCMarksObt"
                        value={loginObj.twlCMarksObt}
                        max={loginObj.twlCMaxMarks}
                        onInput={(e) => {
                          const inputValue = parseInt(e.target.value);
                          const maxMarks = parseInt(
                            e.target.getAttribute("max")
                          );
                          if (inputValue > maxMarks) {
                            e.preventDefault();
                            toast({
                              title: "Alert",
                              description: "Check marks obtained or note below",
                              status: "error",
                              duration: 1000,
                              isClosable: true,
                              position: "top",
                            });
                          }
                          handlePositive(e);
                        }}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value);
                          const maxMarks = parseInt(
                            e.target.getAttribute("max")
                          );
                          if (!isNaN(inputValue) && inputValue <= maxMarks) {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: inputValue,
                            });
                            setTotalObtainedPCBE({
                              ...totalObtainedPCBE,
                              [e.target.name]: inputValue,
                            });
                            setTotalObtainedPCME({
                              ...totalObtainedPCME,
                              [e.target.name]: inputValue,
                            });
                          } else {
                            toast({
                              title: "Alert",
                              description: "Check marks obtained or note below",
                              status: "error",
                              duration: 1000,
                              isClosable: true,
                              position: "top",
                            });
                          }
                        }}
                        onBlur={handlechemBlur}
                        // disabled={
                        //   chemInputDisable ||
                        //   (!editable && !backward) ||
                        //   reversepage
                        // }
                        disabled={
                          chemInputDisable ||
                          (!editable && !backward) ||
                          reversepage ||
                          disableinput
                        }
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-bold w-25 mx-auto text-center pt-3">
                      {" "}
                      English{" "}
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input"
                        placeholder="English Max Marks"
                        name="twlEMaxMarks"
                        value={loginObj.twlEMaxMarks}
                        // value="100"
                        onKeyUp={(e) => handlePositive(e)}
                        onChange={(e) => {
                          setLoginObj({
                            ...loginObj,
                            [e.target.name]: e.target.value,
                          });
                          setTotalPCBE({
                            ...totalPCBE,
                            [e.target.name]: e.target.value,
                          });
                          setTotalPCME({
                            ...totalPCME,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        disabled={
                          loginObj.twlEMarksObt !== "" ||
                          (!editable && !backward)
                        }
                        // disabled={!editable && !backward}

                        required
                      />
                    </td>
                    <td>
                      {/* englishnewcode */}
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input input-3"
                        id="enginput"
                        placeholder="English Marks Obtained"
                        name="twlEMarksObt"
                        value={loginObj.twlEMarksObt}
                        max={loginObj.twlEMaxMarks}
                        onInput={(e) => {
                          const inputValue = parseInt(e.target.value);
                          const maxMarks = parseInt(
                            e.target.getAttribute("max")
                          );
                          if (inputValue > maxMarks) {
                            e.preventDefault();
                            toast({
                              title: "Alert",
                              description: "Check marks obtained or note below",
                              status: "error",
                              duration: 1000,
                              isClosable: true,
                              position: "top",
                            });
                          }
                          handlePositive(e);
                        }}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value);
                          const engMarks = loginObj.twlEMaxMarks;
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= engMarks
                          ) {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: inputValue,
                            });
                            setTotalObtainedPCBE({
                              ...totalObtainedPCBE,
                              [e.target.name]: inputValue,
                            });
                            setTotalObtainedPCME({
                              ...totalObtainedPCME,
                              [e.target.name]: inputValue,
                            });
                          } else {
                            toast({
                              title: "Alert",
                              description: "Check marks obtained or note below",
                              status: "error",
                              duration: 1000,
                              isClosable: true,
                              position: "top",
                            });
                          }
                        }}
                        onBlur={handleengBlur}
                        // disabled={
                        //   enginputDisabled ||
                        //   (!editable && !backward) ||
                        //   reversepage
                        // }
                        disabled={
                          enginputDisabled ||
                          (!editable && !backward) ||
                          reversepage ||
                          disableinput
                        }
                        required
                      />
                    </td>
                  </tr>
                  {loginObj.subjectsName === "PCME" && (
                    <tr>
                      <td className="fw-bold w-25 mx-auto text-center pt-3">
                        {" "}
                        Math{" "}
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control w-75 mx-auto number-input"
                          placeholder="Math Max Marks"
                          name="twlMMaxMarks"
                          value={loginObj.twlMMaxMarks}
                          onKeyUp={(e) => handlePositive(e)}
                          onChange={(e) => {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: e.target.value,
                            });
                            setTotalPCME({
                              ...totalPCME,
                              [e.target.name]: e.target.value,
                            });
                          }}
                          // disabled={!editable && !backward}
                          disabled={
                            loginObj.twlMMarksObt !== "" ||
                            (!editable && !backward)
                          }
                          required
                        />
                      </td>
                      <td>
                        {/* mathmarks */}
                        <input
                          type="number"
                          className="form-control w-75 mx-auto number-input"
                          placeholder="Math marks obtained"
                          name="twlMMarksObt"
                          value={loginObj.twlMMarksObt}
                          max={loginObj.twlMMaxMarks}
                          onInput={(e) => {
                            const inputValue = parseInt(e.target.value);
                            const maxMarks = parseInt(
                              e.target.getAttribute("max")
                            );
                            if (inputValue > maxMarks) {
                              e.preventDefault();
                              toast({
                                title: "Alert",
                                description:
                                  "Check marks obtained or note below",
                                status: "error",
                                duration: 1000,
                                isClosable: true,
                                position: "top",
                              });
                            }
                            handlePositive(e);
                          }}
                          onChange={(e) => {
                            const inputValue = parseInt(e.target.value);
                            const mathMarks = loginObj.twlMMaxMarks;
                            if (!isNaN(inputValue) && inputValue <= mathMarks) {
                              setLoginObj({
                                ...loginObj,
                                [e.target.name]: inputValue,
                              });
                              setTotalObtainedPCME({
                                ...totalObtainedPCME,
                                [e.target.name]: inputValue,
                              });
                            } else {
                              toast({
                                title: "Alert",
                                description:
                                  "Check marks obtained or note below",
                                status: "error",
                                duration: 1000,
                                isClosable: true,
                                position: "top",
                              });
                            }
                          }}
                          onBlur={handlemath}
                          // disabled={
                          //   mathInputDisable ||
                          //   (!editable && !backward) ||
                          //   reversepage
                          // }
                          disabled={
                            mathInputDisable ||
                            (!editable && !backward) ||
                            reversepage ||
                            disableinput
                          }
                          required
                        />
                      </td>
                    </tr>
                  )}
                  {loginObj.subjectsName === "PCBE" && (
                    <tr>
                      <td className="fw-bold w-25 mx-auto text-center pt-3">
                        {" "}
                        Biology{" "}
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control w-75 mx-auto number-input "
                          placeholder="Biology Max Marks"
                          name="twlBMaxMarks"
                          value={loginObj.twlBMaxMarks}
                          onKeyUp={(e) => handlePositive(e)}
                          onChange={(e) => {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: e.target.value,
                            });
                            setTotalPCBE({
                              ...totalPCBE,
                              [e.target.name]: e.target.value,
                            });
                          }}
                          disabled={
                            loginObj.twlBMarksObt !== "" ||
                            (!editable && !backward)
                          }
                          required
                        />
                      </td>
                      <td>
                        {/* bio marks */}
                        <input
                          type="number"
                          className="form-control w-75 mx-auto number-input input-5"
                          placeholder="Biology Marks Obtained"
                          name="twlBMarksObt"
                          value={loginObj.twlBMarksObt}
                          max={loginObj.twlBMaxMarks}
                          onInput={(e) => {
                            const inputValue = parseInt(e.target.value);
                            const maxMarks = parseInt(
                              e.target.getAttribute("max")
                            );
                            if (inputValue > maxMarks) {
                              e.preventDefault();
                              toast({
                                title: "Alert",
                                description:
                                  "Check marks obtained or note below",
                                status: "error",
                                duration: 1000,
                                isClosable: true,
                                position: "top",
                              });
                            }
                            handlePositive(e);
                          }}
                          onChange={(e) => {
                            const inputValue = parseInt(e.target.value);
                            const bioMarks = loginObj.twlBMaxMarks;
                            if (!isNaN(inputValue) && inputValue <= bioMarks) {
                              setLoginObj({
                                ...loginObj,
                                [e.target.name]: inputValue,
                              });
                              setTotalObtainedPCBE({
                                ...totalObtainedPCBE,
                                [e.target.name]: inputValue,
                              });
                            } else {
                              toast({
                                title: "Alert",
                                description:
                                  "Check marks obtained or note below",
                                status: "error",
                                duration: 1000,
                                isClosable: true,
                                position: "top",
                              });
                            }
                          }}
                          onBlur={handlebio}
                          // disabled={
                          //   bioinputDisabled ||
                          //   (!editable && !backward) ||
                          //   reversepage
                          // }
                          disabled={
                            bioinputDisabled ||
                            (!editable && !backward) ||
                            reversepage ||
                            disableinput
                          }
                          required
                        />
                      </td>
                    </tr>
                  )}
                  {loginObj.subjectsName === "PCBME" && (
                    <>
                      <tr>
                        <td className="fw-bold w-25 mx-auto text-center pt-3">
                          {" "}
                          Math{" "}
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control w-75 mx-auto number-input "
                            placeholder="Math Max Marks"
                            name="twlMMaxMarks"
                            value={loginObj.twlMMaxMarks}
                            onKeyUp={(e) => handlePositive(e)}
                            onChange={(e) => {
                              setLoginObj({
                                ...loginObj,
                                [e.target.name]: e.target.value,
                              });
                              setTotalPCME({
                                ...totalPCME,
                                [e.target.name]: e.target.value,
                              });
                            }}
                            disabled={
                              loginObj.twlMMarksObt !== "" ||
                              (!editable && !backward)
                            }
                            // disabled={!editable && !backward}
                            required
                          />
                        </td>
                        <td>
                          {/* newcode for math*/}
                          <input
                            type="number"
                            className="form-control w-75 mx-auto number-input"
                            placeholder="Math marks obtained"
                            name="twlMMarksObt"
                            value={loginObj.twlMMarksObt}
                            maxLength={loginObj.twlMMaxMarks}
                            max={loginObj.twlMMaxMarks}
                            onInput={(e) => {
                              const inputValue = parseInt(e.target.value);
                              const maxMarks = parseInt(
                                e.target.getAttribute("max")
                              );
                              if (inputValue > maxMarks) {
                                e.preventDefault();
                                toast({
                                  title: "Alert",
                                  description:
                                    "Check marks obtained or note below",
                                  status: "error",
                                  duration: 1000,
                                  isClosable: true,
                                  position: "top",
                                });
                              }
                              handlePositive(e);
                            }}
                            onChange={(e) => {
                              const inputValue = parseInt(e.target.value);
                              const mathMarks = loginObj.twlMMaxMarks;
                              if (
                                !isNaN(inputValue) &&
                                inputValue <= mathMarks
                              ) {
                                setLoginObj({
                                  ...loginObj,
                                  [e.target.name]: inputValue,
                                });
                                setTotalObtainedPCME({
                                  ...totalObtainedPCME,
                                  [e.target.name]: inputValue,
                                });
                              } else {
                                toast({
                                  title: "Alert",
                                  description:
                                    "Check marks obtained or note below",
                                  status: "error",
                                  duration: 1000,
                                  isClosable: true,
                                  position: "top",
                                });
                              }
                            }}
                            onBlur={handlemath}
                            disabled={
                              mathInputDisable ||
                              (!editable && !backward) ||
                              reversepage ||
                              disableinput
                            }
                            // disabled={
                            //   mathInputDisable ||
                            //   (!editable && !backward) ||
                            //   reversepage
                            // }
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold w-25 mx-auto text-center pt-3">
                          {" "}
                          Biology{" "}
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control w-75 mx-auto number-input"
                            placeholder="Biology Max Marks"
                            name="twlBMaxMarks"
                            value={loginObj.twlBMaxMarks}
                            onKeyUp={(e) => handlePositive(e)}
                            onChange={(e) => {
                              setLoginObj({
                                ...loginObj,
                                [e.target.name]: e.target.value,
                              });
                              setTotalPCBE({
                                ...totalPCBE,
                                [e.target.name]: e.target.value,
                              });
                            }}
                            disabled={
                              loginObj.twlBMarksObt !== "" ||
                              (!editable && !backward)
                            }
                            required
                          />
                        </td>
                        <td>
                          {/* new code */}
                          <input
                            type="number"
                            className="form-control w-75 mx-auto number-input"
                            placeholder="Biology Marks Obtained"
                            name="twlBMarksObt"
                            value={loginObj.twlBMarksObt}
                            maxLength={loginObj.twlBMaxMarks}
                            max={loginObj.twlBMaxMarks}
                            onInput={(e) => {
                              const inputValue = parseInt(e.target.value);
                              const maxMarks = parseInt(
                                e.target.getAttribute("max")
                              );
                              if (inputValue > maxMarks) {
                                e.preventDefault();
                                toast({
                                  title: "Alert",
                                  description:
                                    "Check marks obtained or note below",
                                  status: "error",
                                  duration: 1000,
                                  isClosable: true,
                                  position: "top",
                                });
                              }
                              handlePositive(e);
                            }}
                            onChange={(e) => {
                              const inputValue = parseInt(e.target.value);
                              const mathMarks = loginObj.twlMMaxMarks;
                              if (
                                !isNaN(inputValue) &&
                                inputValue <= mathMarks
                              ) {
                                setLoginObj({
                                  ...loginObj,
                                  [e.target.name]: inputValue,
                                });
                                setTotalObtainedPCBE({
                                  ...totalObtainedPCBE,
                                  [e.target.name]: inputValue,
                                });
                              } else {
                                toast({
                                  title: "Alert",
                                  description:
                                    "Check marks obtained or note below",
                                  status: "error",
                                  duration: 1000,
                                  isClosable: true,
                                  position: "top",
                                });
                              }
                            }}
                            onBlur={handlebio}
                            disabled={
                              bioinputDisabled ||
                              (!editable && !backward) ||
                              reversepage ||
                              disableinput
                            }
                            // disabled={
                            //   bioinputDisabled ||
                            //   (!editable && !backward) ||
                            //   reversepage
                            // }
                            required
                          />
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>

            <div className="row p-3">
              {loginObj.subjectsName === "PCBE" && (
                <>
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">Max. Marks (PCBE)</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Maximum Marks"
                      name="twlMaxMarksPCBE"
                      value={loginObj.twlMaxMarksPCBE}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                      readOnly
                      required
                    />
                  </div>

                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Total Marks Obtained (PCBE)
                    </label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Total Marks"
                      name="twlPCBEMarks"
                      value={loginObj.twlPCBEMarks}
                      readOnly
                      required
                    />
                  </div>
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">Percentage in (PCBE)*</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Percentage"
                      name="twlPCBEPercentage"
                      value={loginObj.twlPCBEPercentage}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                      readOnly
                      required
                    />
                  </div>
                </>
              )}
              {loginObj.subjectsName === "PCME" && (
                <>
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">Max. Marks (PCME)</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Maximum Marks"
                      name="twlMaxMarksPCME"
                      value={loginObj.twlMaxMarksPCME}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                      readOnly
                      required
                    />
                  </div>

                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Total Marks Obtained (PCME)
                    </label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Total marks"
                      name="twlPCMEMarks"
                      value={loginObj.twlPCMEMarks}
                      onChange={handlePositive}
                      readOnly
                      required
                    />
                  </div>
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">Percentage in (PCME)*</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Percentage"
                      name="twlPCMEPercentage"
                      value={loginObj.twlPCMEPercentage}
                      // onChange={(e) =>
                      //   setLoginObj({
                      //     ...loginObj,
                      //     [e.target.name]: e.target.value,
                      //   })
                      // }
                      required
                      readOnly
                    />
                  </div>
                </>
              )}
              {loginObj.subjectsName === "PCBME" && (
                <>
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">Max. Marks (PCME)</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Maximum Marks"
                      name="twlMaxMarksPCME"
                      value={loginObj.twlMaxMarksPCME}
                      // onChange={(e) =>
                      //   setLoginObj({
                      //     ...loginObj,
                      //     [e.target.name]: e.target.value,
                      //   })
                      // }
                      readOnly
                      required
                    />
                  </div>

                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Total Marks Obtained (PCME)
                    </label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Total Marks"
                      name="twlPCMEMarks"
                      value={loginObj.twlPCMEMarks}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                      readOnly
                      required
                    />
                  </div>

                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">Percentage in (PCME)*</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Percentage"
                      name="twlPCMEPercentage"
                      value={loginObj.twlPCMEPercentage}
                      // onChange={(e) =>
                      //   setLoginObj({
                      //     ...loginObj,
                      //     [e.target.name]: e.target.value,
                      //   })
                      // }
                      required
                      readOnly
                    />
                  </div>

                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">Max. Marks (PCBE)</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Maximum Marks"
                      name="twlMaxMarksPCBE"
                      value={loginObj.twlMaxMarksPCBE}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                      readOnly
                      required
                    />
                  </div>

                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Total Marks Obtained (PCBE)
                    </label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Total Marks"
                      name="twlPCBEMarks"
                      value={loginObj.twlPCBEMarks}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                      readOnly
                      required
                    />
                  </div>
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">Percentage in (PCBE)*</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Percentage"
                      name="twlPCBEPercentage"
                      value={loginObj.twlPCBEPercentage}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                      readOnly
                      required
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="row justify-content-around my-5">
            <div style={{ color: "#ed0909" }}>
              <label>Note:</label>
              <h6>
                Please click on "Set Marks" button for entering marks or edit
                marks submitted. In case marks not submitted may first select
                the value of marks to be changed and then punch the desired
                numeric value.
              </h6>
            </div>

            {loginObj.subjectsName === "PCBE" && (
              <button
                type="submit"
                className="btn btn-primary w-25"
                disabled={
                  fp2loader ||
                  !loginObj.twlBMarksObt ||
                  !loginObj.twlEMarksObt ||
                  !loginObj.twlCMarksObt ||
                  !loginObj.twlPMarksObt
                }
              >
                Submit
                {fp2loader && <Loader />}
              </button>
            )}

            {loginObj.subjectsName === "PCME" && (
              <button
                type="submit"
                className="btn btn-primary w-25"
                disabled={
                  fp2loader ||
                  !loginObj.twlMMarksObt ||
                  !loginObj.twlEMarksObt ||
                  !loginObj.twlCMarksObt ||
                  !loginObj.twlPMarksObt
                }
              >
                Submit
                {fp2loader && <Loader />}
              </button>
            )}

            {loginObj.subjectsName === "PCBME" && (
              <button
                type="submit"
                className="btn btn-primary w-25"
                disabled={
                  fp2loader ||
                  !loginObj.twlBMarksObt ||
                  !loginObj.twlMMarksObt ||
                  !loginObj.twlEMarksObt ||
                  !loginObj.twlCMarksObt ||
                  !loginObj.twlPMarksObt
                }
              >
                Submit
                {fp2loader && <Loader />}
              </button>
            )}

            {/* <button
              type="submit"
              className="btn btn-primary w-25"
              disabled={fp2loader}
            >
              Submit
              {fp2loader && <Loader />}
            </button>  */}
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}

export default FormPage2;
